import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from "../../services/api";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import ModalImportacao from "./ModalConc/ModalConcImportacao";
import ModalTaxa from "./ModalConc/ModalConcTaxa";
import ModalManual from "./ModalConc/ModalConcManual";
import ModalAssociacao from "./ModalConc/ModalConcAssociacao";
import ModalExcluir from "./ModalConc/ModalConcExclui";
import { Modal, Spinner, Form, Card, Row, Col, Button, Table } from 'react-bootstrap';
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
    FaFileExcel, FaStore,
    FaArrowUp, FaArrowDown,
    FaPercent,
    FaMoneyBillWave,
    FaLaptop,
    FaCopy,
    FaBalanceScale,
    FaSortAmountDown,
    FaGripVertical,
    FaSearch
} from "react-icons/fa";

export default function ConciliacaoCartao() {
    const navigate = useNavigate();

    // Estados de Controle de Modal
    const [showModalImport, setShowModalImport] = useState(false);
    const [showModalTaxa, setShowModalTaxa] = useState(false);
    const [showModalManual, setShowModalManual] = useState(false);
    const [showModalAssociacao, setShowModalAssociacao] = useState(false);
    const [showModalExcluir, setShowModalExcluir] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lista, setLista] = useState([]);

    // Estados de Totais
    const [totais, setTotais] = useState({
        bruto: 0, taxa: 0, liquido: 0, software: 0,
        duplicidade: 0, liquido_duplicidade: 0, duplicidade_se: 0, valorse: 0
    });

    // CONTROLES DE GRID (FILTRO / SORT / DRAG)
    const [filtroGrid, setFiltroGrid] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Definição das Colunas
    const [colunas, setColunas] = useState([
        { key: 'loja', label: 'Loja', visibleKey: 'checkLoja' },
        { key: 'datavenda', label: 'Data Venda', visibleKey: 'checkVenda', isDate: true },
        { key: 'roteamento', label: 'Roteamento', visibleKey: 'checkRoteamento' },
        { key: 'bandeira', label: 'Bandeira', visibleKey: 'checkBandeira' },
        { key: 'condicao', label: 'Condição', visibleKey: 'checkCondicao' },
        { key: 'datacredito', label: 'Crédito', visibleKey: 'checkCredito', isDate: true },
        { key: 'valorbruto', label: 'Bruto', alwaysVisible: true, isNumeric: true },
        { key: 'taxa', label: 'Taxa (%)', alwaysVisible: true, isNumeric: true },
        { key: 'valortaxa', label: 'Vlr. Taxa', alwaysVisible: true, isNumeric: true },
        { key: 'valorliq', label: 'Líquido', alwaysVisible: true, isNumeric: true },
        { key: 'valorse', label: 'Líquido SE', alwaysVisible: true, isNumeric: true }
    ]);

    // Drag & Drop de Colunas
    const handleDragStart = (e, index) => e.dataTransfer.setData("colIndex", index);
    const handleDrop = (e, targetIndex) => {
        const sourceIndex = e.dataTransfer.getData("colIndex");
        const newCols = [...colunas];
        const [movedCol] = newCols.splice(sourceIndex, 1);
        newCols.splice(targetIndex, 0, movedCol);
        setColunas(newCols);
    };

    // Lógica de Filtro Local
    const getDistinctValues = (key, isDate) => {
        const values = lista.map(item => isDate ? formatarDataParaBR(item[key]) : item[key]);
        return [...new Set(values)].filter(Boolean).sort();
    };

    // Processamento da Lista
    const listaExibicao = useMemo(() => {
        let dados = [...lista];

        Object.keys(filtroGrid).forEach(key => {
            if (filtroGrid[key]) {
                dados = dados.filter(item => {
                    const col = colunas.find(c => c.key === key);
                    const val = col?.isDate ? formatarDataParaBR(item[key]) : item[key];
                    return String(val) === String(filtroGrid[key]);
                });
            }
        });

        if (sortConfig.key) {
            dados.sort((a, b) => {
                let v1 = a[sortConfig.key];
                let v2 = b[sortConfig.key];
                if (v1 < v2) return sortConfig.direction === 'asc' ? -1 : 1;
                if (v1 > v2) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        return dados;
    }, [lista, filtroGrid, sortConfig, colunas]);

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    useEffect(() => {
        const usuario = localStorage.getItem("chapa");
        const permiteConciliacao = localStorage.getItem("CONCILIACARTAO");
        if (!usuario) { navigate("/arbor/login"); return; }
        if (permiteConciliacao !== "S") {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Não é permitido acessar o módulo de conciliação.',
                confirmButtonText: 'OK'
            }).then(() => { navigate("/arbor/home"); });
        }
    }, [navigate]);

    const agora = new Date();
    const hoje = agora.toISOString().split('T')[0];
    const primeiroDiaDoMes = new Date(agora.getFullYear(), agora.getMonth(), 1).toISOString().split('T')[0];

    const [filtros, setFiltros] = useState({
        dataInicio: primeiroDiaDoMes,
        dataFim: hoje,
        checkLoja: true,
        checkVenda: true,
        checkRoteamento: false,
        checkBandeira: false,
        checkCondicao: false,
        checkCredito: false
    });

    const formatarNumero = (valor) => new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor || 0);

    const formatarDataParaBR = (dataIso) => {
        if (!dataIso) return '';
        try {
            const limpa = dataIso.replace('Z', '');
            const d = new Date(limpa);
            return isNaN(d) ? dataIso : d.toLocaleDateString('pt-BR');
        } catch { return dataIso; }
    };

    const formatarDataFiltro = (dataIso) => {
        if (!dataIso) return '';
        const [ano, mes, dia] = dataIso.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    const calcularDiferenca = () => {
        const liquido = Number(totais.liquido || 0);
        const liquidoDup = Number(totais.liquido_duplicidade || 0);
        const software = Number(totais.software || 0);
        const duplSe = Number(totais.duplicidade_se || 0);
        return ((liquido - liquidoDup) - software) - duplSe;
    };

    const handleConsultar = async () => {
        const algumMarcado = filtros.checkLoja || filtros.checkVenda || filtros.checkRoteamento || filtros.checkBandeira || filtros.checkCondicao || filtros.checkCredito;
        if (!algumMarcado) { Swal.fire("Erro", "Selecione ao menos um agrupamento.", "error"); return; }
        setLoading(true);
        try {
            const params = {
                ...filtros,
                dataInicio: formatarDataFiltro(filtros.dataInicio),
                dataFim: formatarDataFiltro(filtros.dataFim)
            };
            const res = await api.get('/financeiro/conciliacao', { params });
            setLista(res.data?.dados || []);
            setTotais(res.data?.resumo || {});
        } catch (err) {
            Swal.fire("Erro", "Falha ao consultar dados", "error");
        } finally {
            setTimeout(() => setLoading(false), 400);
        }
    };

    const handleExportExcel = () => {
        if (!listaExibicao || listaExibicao.length === 0) {
            Swal.fire("Aviso", "Não há dados para exportar.", "warning");
            return;
        }
        try {
            const montarLinha = (row) => {
                const obj = {};
                obj["Cód. Cadastro"] = row.codicadastro || "";
                if (filtros.checkLoja) obj["Loja"] = row.loja;
                if (filtros.checkVenda) obj["Data Venda"] = formatarDataParaBR(row.datavenda);
                if (filtros.checkRoteamento) obj["Roteamento"] = row.roteamento;
                if (filtros.checkBandeira) obj["Bandeira"] = row.bandeira;
                if (filtros.checkCondicao) obj["Condição"] = row.condicao;
                if (filtros.checkCredito) obj["Crédito"] = formatarDataParaBR(row.datacredito);
                obj["Bruto"] = Number(row.valorbruto || 0);
                obj["Taxa (%)"] = Number(row.taxa || 0);
                obj["Vlr. Taxa"] = Number(row.valortaxa || 0);
                obj["Líquido"] = Number(row.valorliq || 0);
                obj["Líquido SE"] = Number(row.valorse || 0);
                return obj;
            };

            const dadosExcel = listaExibicao.map(montarLinha);
            const ws = XLSX.utils.json_to_sheet(dadosExcel);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Conciliacao");
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, `Conciliacao_${filtros.dataInicio}_${filtros.dataFim}.xlsx`);
            Swal.fire("Sucesso", "Excel gerado com sucesso!", "success");
        } catch (err) {
            Swal.fire("Erro", "Falha ao exportar Excel.", "error");
        }
    };

    return (
        <div className="bg-light min-vh-100 d-flex flex-column">
            <Menu modulo="ARBOR" />

            <Modal show={loading} centered backdrop="static" keyboard={false} size="sm">
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" style={{ color: '#8b0000' }} className="mb-3" />
                    <div className="fw-bold text-dark">Consultando dados...</div>
                    <small className="text-muted">Aguarde um momento</small>
                </Modal.Body>
            </Modal>

            <main className="container-fluid flex-grow-1" style={{ paddingTop: '95px', paddingBottom: '20px' }}>
                
                {/* Painel de Filtros */}
                <Card className="shadow-sm border-0 mb-3 rounded-3">
                    <Card.Body className="p-3">
                        <Row className="g-3 align-items-end">
                            <Col md={2} sm={6}>
                                <Form.Label className="small fw-bold text-secondary mb-1">Data Início</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    size="sm" 
                                    className="border-1" 
                                    value={filtros.dataInicio} 
                                    onChange={e => setFiltros({ ...filtros, dataInicio: e.target.value })} 
                                />
                            </Col>
                            <Col md={2} sm={6}>
                                <Form.Label className="small fw-bold text-secondary mb-1">Data Fim</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    size="sm" 
                                    className="border-1" 
                                    value={filtros.dataFim} 
                                    onChange={e => setFiltros({ ...filtros, dataFim: e.target.value })} 
                                />
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Label className="small fw-bold text-secondary mb-1 d-block">Agrupar por</Form.Label>
                                <div className="d-flex flex-wrap gap-1">
                                    {['Loja', 'Venda', 'Roteamento', 'Bandeira', 'Condicao', 'Credito'].map(f => (
                                        <div key={f}>
                                            <input 
                                                type="checkbox" 
                                                className="btn-check" 
                                                id={`chk${f}`} 
                                                checked={filtros[`check${f}`]} 
                                                onChange={e => setFiltros({ ...filtros, [`check${f}`]: e.target.checked })} 
                                            />
                                            <label 
                                                htmlFor={`chk${f}`} 
                                                className="btn btn-outline-secondary btn-sm py-1 px-2 rounded-2" 
                                                style={{ fontSize: '0.75rem', fontWeight: 500 }}
                                            >
                                                {f}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col md={4} sm={12} className="d-flex justify-content-md-end flex-wrap gap-2">
                                <Button variant="primary" size="sm" className="fw-bold px-3 shadow-sm d-flex align-items-center gap-1" onClick={handleConsultar}>
                                    <FaSearch size={12} /> Pesquisar
                                </Button>
                                <Button variant="outline-primary" size="sm" className="fw-bold px-2 shadow-sm" onClick={() => setShowModalManual(true)}>
                                    Manual
                                </Button>
                                <Button variant="outline-success" size="sm" className="fw-bold px-2 shadow-sm" onClick={() => setShowModalTaxa(true)}>
                                    Taxas
                                </Button>
                                <Button variant="outline-warning" size="sm" className="fw-bold px-2 shadow-sm text-dark" onClick={() => setShowModalImport(true)}>
                                    Importar
                                </Button>
                                <Button variant="outline-dark" size="sm" className="fw-bold px-2 shadow-sm" onClick={() => setShowModalAssociacao(true)}>
                                    Associar
                                </Button>
                                <Button variant="success" size="sm" className="fw-bold px-2 shadow-sm d-flex align-items-center gap-1" onClick={handleExportExcel}>
                                    <FaFileExcel size={12} /> Excel
                                </Button>
                                <Button variant="outline-danger" size="sm" className="fw-bold px-2 shadow-sm" onClick={() => setShowModalExcluir(true)}>
                                    Limpar
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Tabela de Dados */}
                <Card className="shadow-sm border-0 mb-3 rounded-3 overflow-hidden">
                    <div className="table-responsive" style={{ maxHeight: '55vh' }}>
                        <Table hover bordered size="sm" className="mb-0 align-middle">
                            <thead className="table-dark sticky-top text-center align-middle" style={{ zIndex: 10 }}>
                                <tr>
                                    {colunas.map((col, idx) => {
                                        if (!col.alwaysVisible && !filtros[col.visibleKey]) return null;
                                        return (
                                            <th
                                                key={col.key}
                                                draggable
                                                onDragStart={(e) => handleDragStart(e, idx)}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={(e) => handleDrop(e, idx)}
                                                className="bg-dark text-white fw-semibold border-secondary"
                                                style={{ cursor: 'grab', minWidth: '120px', padding: '6px' }}
                                            >
                                                <div className="d-flex align-items-center justify-content-between px-1 mb-1">
                                                    <FaGripVertical size={10} className="text-secondary" />
                                                    <span style={{ fontSize: '0.75rem' }}>{col.label}</span>
                                                    <FaSortAmountDown
                                                        size={12}
                                                        className="text-white-50 cursor-pointer hover-opacity-100"
                                                        onClick={() => handleSort(col.key)}
                                                    />
                                                </div>
                                                <Form.Select
                                                    size="sm"
                                                    className="py-0 px-1 border-secondary shadow-none text-white rounded-1"
                                                    style={{ fontSize: '0.65rem', backgroundColor: '#343a40' }}
                                                    value={filtroGrid[col.key] || ""}
                                                    onChange={(e) => setFiltroGrid({ ...filtroGrid, [col.key]: e.target.value })}
                                                >
                                                    <option value="">(Tudo)</option>
                                                    {getDistinctValues(col.key, col.isDate).map(v => (
                                                        <option key={v} value={v}>{v}</option>
                                                    ))}
                                                </Form.Select>
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody className="small">
                                {listaExibicao.map((row, i) => (
                                    <tr key={i} className="text-center">
                                        {colunas.map(col => {
                                            if (!col.alwaysVisible && !filtros[col.visibleKey]) return null;

                                            if (col.key === 'valorse') {
                                                return (
                                                    <td key={col.key} className="text-end fw-bold text-success px-2">
                                                        <div className="d-flex align-items-center justify-content-end gap-1">
                                                            {row.valorse > row.valorliq && <FaArrowUp size={11} className="text-success" title="Maior que o Líquido" />}
                                                            {row.valorse < row.valorliq && <FaArrowDown size={11} className="text-danger" title="Menor que o Líquido" />}
                                                            <span>{formatarNumero(row.valorse)}</span>
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            let valor = row[col.key];
                                            if (col.isDate) valor = formatarDataParaBR(valor);
                                            if (col.isNumeric) valor = formatarNumero(valor);

                                            return (
                                                <td key={col.key} className={col.isNumeric ? "text-end px-2" : ""}>
                                                    {valor}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                {listaExibicao.length === 0 && (
                                    <tr>
                                        <td colSpan={colunas.length} className="text-center py-4 text-muted">
                                            Nenhum registro encontrado para os filtros selecionados.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card>

                {/* Dashboard de Totais */}
                <div className="bg-white p-2 rounded-3 shadow-sm border">
                    <Row className="g-2">
                        <CardTotal icon={<FaMoneyBillWave />} label="BRUTO" value={totais.bruto} bg="vermelho" />
                        <CardTotal icon={<FaPercent />} label="TAXA" value={totais.taxa} bg="danger" />
                        <CardTotal icon={<FaStore />} label="LÍQUIDO" value={totais.liquido} bg="success" />
                        <CardTotal icon={<FaLaptop />} label="LÍQUIDO SE" value={totais.software} bg="warning" />
                        <CardTotal icon={<FaCopy />} label="DUPLICIDADE" value={totais.duplicidade} bg="secondary" />
                        <CardTotal
                            icon={<FaBalanceScale />}
                            label="DIFERENÇA"
                            value={calcularDiferenca()}
                            bg={calcularDiferenca() === 0 ? "info" : "dark"}
                            highlight={calcularDiferenca() !== 0}
                        />
                    </Row>
                </div>
            </main>

            {/* Modais */}
            <ModalImportacao show={showModalImport} onHide={() => setShowModalImport(false)} />
            <ModalTaxa show={showModalTaxa} onHide={() => setShowModalTaxa(false)} />
            <ModalManual
                show={showModalManual}
                onHide={() => setShowModalManual(false)}
                onSuccess={handleConsultar}
                dataInicio={formatarDataFiltro(filtros.dataInicio)}
                dataFim={formatarDataFiltro(filtros.dataFim)}
            />
            <ModalAssociacao show={showModalAssociacao} onHide={() => setShowModalAssociacao(false)} onSuccess={handleConsultar} />
            <ModalExcluir show={showModalExcluir} onHide={() => setShowModalExcluir(false)} onSuccess={handleConsultar} />

            <Footer />
        </div>
    );
}

function CardTotal({ label, value, bg, icon, highlight }) {
    const formatarMoedaLocal = (valor) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor || 0);

    const coresFundo = {
        vermelho: '#8b0000',
        primary: '#8b0000',
        danger: '#dc3545',
        success: '#198754',
        warning: '#ffc107',
        secondary: '#6c757d',
        info: '#0dcaf0',
        dark: '#212529'
    };

    const backgroundColor = coresFundo[bg] || '#8b0000';
    const color = bg === 'warning' ? '#000' : '#fff';

    return (
        <Col xs={6} md={2}>
            <div 
                className="shadow-sm h-100 d-flex flex-column justify-content-center p-2 rounded-3 text-center" 
                style={{ 
                    backgroundColor: backgroundColor,
                    color: color,
                    transform: highlight ? 'scale(1.02)' : 'scale(1)', 
                    transition: 'all .2s ease-in-out' 
                }}
            >
                <div className="d-flex align-items-center justify-content-center gap-1 mb-1 opacity-75">
                    <span style={{ fontSize: '0.85rem' }}>{icon}</span>
                    <span style={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.5px' }}>{label}</span>
                </div>
                <div style={{ fontSize: '1.05rem', fontWeight: 800 }}>
                    {formatarMoedaLocal(value)}
                </div>
                {highlight && (
                    <div className="mt-1">
                        <small className="badge bg-danger text-white border border-light" style={{ fontSize: '0.6rem' }}>⚠ Divergência</small>
                    </div>
                )}
            </div>
        </Col>
    );
}